import React, { useEffect, useState } from 'react';
import { getMiUsuario, editarMiUsuario } from '../services/usuarioService';
import CamposUsuario from './CamposUsuario';
import { ROLES } from '../utils/roles';
import { perfilSchema } from '../utils/validation';

const UsuarioForm = ({ emailUsuarioActual, rol, onGuardar }) => {
    const [usuario, setUsuario] = useState(null);
    const [form, setForm] = useState({
        email: '', dni: '', firstName: '', lastName: '', password: '',
    });
    const [errors, setErrors] = useState({});
    const [mensaje, setMensaje] = useState('');

    useEffect(() => {
        const fetchUsuario = async () => {
            try {
                const data = await getMiUsuario(emailUsuarioActual);
                setUsuario(data);
                setForm({
                    email: data.email, dni: data.dni,
                    firstName: data.firstName, lastName: data.lastName, password: '',
                });
            } catch (error) {
                console.error('Error al obtener usuario:', error);
                setMensaje(error?.response?.data?.mensaje || 'Error desconocido');
            }
        };
        fetchUsuario();
    }, [emailUsuarioActual]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: undefined }));
    };

    const handleSubmit = async () => {
        const result = perfilSchema.safeParse(form);
        if (!result.success) {
            const fieldErrors = {};
            result.error.issues.forEach((i) => { fieldErrors[i.path[0]] = i.message; });
            setErrors(fieldErrors);
            return;
        }
        try {
            const dataEdit = {
                email: form.email, dni: form.dni,
                firstName: result.data.firstName, lastName: result.data.lastName, password: result.data.password,
            };
            const actualizado = await editarMiUsuario(dataEdit);
            setUsuario(actualizado);
            setMensaje('Datos actualizados correctamente');
            if (onGuardar) onGuardar();
        } catch (e) {
            setMensaje(e?.response?.data?.mensaje || 'Error al actualizar');
        }
    };

    if (!usuario) return <p className="text-sm text-gray-400 italic text-center">Cargando usuario...</p>;

    return (
        <div className="space-y-4">
            <h2 className="text-lg font-semibold text-gray-900 text-center">Mi Perfil</h2>
            <CamposUsuario form={form} onChange={handleChange} soloPassword={rol === ROLES.EMPLEADO} errors={errors} />
            <button className="w-full py-2.5 px-4 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 transition-colors" onClick={handleSubmit}>
                Guardar cambios
            </button>
            {mensaje && <p className="text-sm text-center font-medium text-green-600">{mensaje}</p>}
        </div>
    );
};

export default UsuarioForm;
